import { Editor as TinyMCEEditor, RawEditorOptions } from "tinymce";

import { IEvents } from "../Events";

export interface IREditorBaseProps {
    apiKey: string;
    id: string;
    dataKey: string;
    inline: boolean;
    initialValue: string;
    onEditorChange: (a: string, editor: TinyMCEEditor) => void;
    value: string;
    init: RawEditorOptions & { selector?: undefined; target?: undefined };
    /** @deprecated use `editor.getContent({format: 'text' })` in `onEditorChange` prop instead */
    outputFormat: "html" | "text";
    tagName: string;
    cloudChannel: string;
    plugins: NonNullable<RawEditorOptions["plugins"]>;
    toolbar: NonNullable<RawEditorOptions["toolbar"]>;
    disabled: boolean;
    textareaName: string;
    tinymceScriptSrc: string;
    scriptLoading: {
        async?: boolean;
        defer?: boolean;
        delay?: number;
    };
    isValid?: boolean;
    darkTheme?: boolean;
}

/**
 * Enumerátory sloužící pro nastavení skinu a CSS RichTextEditoru pro světlý a tmavý motiv multiwebu.
 * Více na https://www.tiny.cloud/docs/general-configuration-guide/customize-ui/#skins
 */
export enum REditorSkin {
    light = "oxide",
    dark = "oxide-dark",
}

export enum REditorCSS {
    light = "default",
    dark = "dark",
}

export interface IRichTextEditorWrapperProps extends Partial<IREditorBaseProps>, Partial<IEvents> { }
